import { cn } from '@ctct/summit-core';
import { Command as CommandPrimitive } from 'cmdk';
import { type ComponentPropsWithoutRef, type ElementRef, forwardRef } from 'react';

/**
 * Adds unclickable subheading to group of items
 */
const CommandGroup = forwardRef<
  ElementRef<typeof CommandPrimitive.Group>,
  ComponentPropsWithoutRef<typeof CommandPrimitive.Group>
>(({ className, ...props }, ref) => (
  <CommandPrimitive.Group
    ref={ref}
    className={cn(
      'rds-command-group',
      `
        r:p-1 r:overflow-hidden
        r:text-(--text)
        r:[&_[cmdk-group-heading]]:px-2
        r:[&_[cmdk-group-heading]]:py-1.5
        r:[&_[cmdk-group-heading]]:text-xs
        r:[&_[cmdk-group-heading]]:font-medium
        r:[&_[cmdk-group-heading]]:text-(--text-placeholder)
      `,
      className
    )}
    data-sds-id="command-group"
    {...props}
  />
));

CommandGroup.displayName = 'CommandGroup';

export { CommandGroup };
